export const footerLinks = {
  about: [
    { name: 'about', href: 'https://finary.com/about-us' },
    { name: 'security', href: 'https://finary.com/security' },
    { name: 'Finary plus', href: 'https://finary.com/finary-plus', noTrad: true },
    { name: 'jobs', href: 'https://jobs.ashbyhq.com/finary' },
    { name: 'blog', href: 'https://finary.com/en/blog/' },
    { name: 'community', href: 'https://community.finary.com/' },
    {
      name: 'roadmap',
      href: 'https://www.notion.so/finarywealth/Finary-Public-Roadmap-bab44d9f05164470a2e9f7962f5d08ed',
    },
    {
      name: 'press',
      href: 'https://www.notion.so/finarywealth/propos-de-Finary-30b820be6803404b8b38c38d6630ba61',
    },
    {
      name: 'changelog',
      href: 'https://finarywealth.notion.site/Finary-Changelog-8ed0e377f0d84881a257a276050b1ada',
    },
  ],
  invest: [
    {
      name: 'Simulateur de patrimoine',
      href: '/tools/wealth-simulator',
      noTrad: true,
    },
    {
      name: 'Calculateur de budget',
      href: '/tools/budget-calculator',
      noTrad: true,
    },
    {
      name: 'Aggrégateur de compte',
      href: 'https://finary.com/fr/blog/finance-perso/budget/agregateur-de-compte',
      noTrad: true,
    },
    {
      name: 'Gestion de Patrimoine',
      noTrad: true,
      subsection: [
        {
          name: 'Gestion de patrimoine',
          href: 'https://finary.com/fr/blog/epargne/ou-placer/comment-investir/guide-de-la-gestion-de-patrimoine',
        },
        {
          name: 'Conseiller en patrimoine',
          href: 'https://finary.com/fr/blog/epargne/ou-placer/comment-investir/conseiller-en-gestion-de-patrimoine',
        },
        {
          name: 'Logiciel gestion de patrimoine',
          href: 'https://finary.com/fr/blog/epargne/ou-placer/comment-investir/logiciel-gestion-de-patrimoine',
        },
        {
          name: 'Apport cession',
          href: 'https://finary.com/fr/blog/epargne/exotique/venture-capital/dispositif-apport-cession',
        },
        {
          name: 'Conseil en investissement financier',
          href: 'https://finary.com/fr/blog/epargne/ou-placer/comment-investir/conseil-en-investissement',
        },
        {
          name: 'Patrimoine moyen des francais',
          href: 'https://finary.com/fr/blog/epargne/ou-placer/comment-investir/patrimoine-moyen-des-francais',
        },
      ],
    },
    {
      name: 'Investir en Bourse',
      noTrad: true,
      subsection: [
        { name: 'Investir en bourse', href: 'https://finary.com/fr/blog/bourse' },
        {
          name: 'Acheter des actions',
          href: 'https://finary.com/fr/blog/bourse/actions/comment-acheter-des-actions',
        },
        {
          name: 'ETF',
          href: 'https://finary.com/fr/blog/bourse/etf/etf-tout-savoir',
        },
      ],
    },
    {
      name: 'Comment Investir',
      noTrad: true,
      subsection: [
        {
          name: 'Comment investir',
          href: 'https://finary.com/fr/blog/epargne/ou-placer/comment-investir/guide',
        },
        {
          name: 'Ou investir 20 000€',
          href: 'https://finary.com/fr/blog/epargne/ou-placer/comment-investir/investir-20-000-euros',
        },
        {
          name: 'Investir 50 000€',
          href: 'https://finary.com/fr/blog/epargne/ou-placer/comment-investir/investir-50-000-euros',
        },
        {
          name: 'Placer 300 000€',
          href: 'https://finary.com/fr/blog/epargne/ou-placer/comment-investir/investir-300-000-euros',
        },
        {
          name: 'Placer 400 000€',
          href: 'https://finary.com/fr/blog/epargne/ou-placer/comment-investir/investir-400-000-euros',
        },
        {
          name: 'Placer 500 000€',
          href: 'https://finary.com/fr/blog/epargne/ou-placer/comment-investir/investir-500-000',
        },
        {
          name: 'Investir son argent : Les 6 erreurs à eviter',
          href: 'https://finary.com/fr/blog/epargne/ou-placer/comment-investir/investir-son-argent-6-erreurs-a-eviter',
        },
        {
          name: 'Épargne de précaution : Pourquoi est-ce indispensable ?',
          href: 'https://finary.com/fr/blog/epargne/ou-placer/comment-investir/epargne-de-precaution',
        },
        {
          name: 'Faut-il choisir la gestion pilotée',
          href: 'https://finary.com/fr/blog/epargne/assurance-vie/gestion-pilotee',
        },
        {
          name: 'FPCR : Investir dans les entreprise non côtées',
          href: 'https://finary.com/fr/blog/epargne/exotique/venture-capital/fpcr-non-cote',
        },
      ],
    },
    { name: 'excel', href: '/excel-patrimoine' },
    {
      name: 'PEA',
      noTrad: true,
      subsection: [
        {
          name: 'Tout savoir sur le PEA',
          href: 'https://finary.com/fr/blog/epargne/plans/pea/guide-pea',
        },
        {
          name: 'Peut-on avoir plusieurs PEA',
          href: 'https://finary.com/fr/blog/epargne/plans/pea/peut-on-avoir-plusieurs-pea',
        },
        {
          name: 'Quelle fiscalité pour le PEA ?',
          href: 'https://finary.com/fr/blog/epargne/plans/pea/fiscalite-pea',
        },
        {
          name: 'Quels sont les atouts du PEA Assurance ?',
          href: 'https://finary.com/fr/blog/epargne/plans/pea/quels-atouts-pea-assurance',
        },
      ],
    },
    {
      name: 'Investir crypto monnaie',
      noTrad: true,
      href: 'https://finary.com/invest/crypto',
    },
  ],
  legal: [
    { name: 'contact_us', href: 'mailto:hello@finary.com' },
    { name: 'help', href: 'https://help.finary.com', specifyLocale: true },
    { name: 'mentions', href: 'https://finary.com/legal' },
    { name: 'cookies', href: 'https://finary.com/cookies' },
    { name: 'legal', href: 'https://finary.com/terms' },
    { name: 'privacy', href: 'https://finary.com/privacy' },
  ],
};

export const socialLinks = [
  { src: 'instagram', href: 'https://www.instagram.com/finaryhq/?hl=fr' },
  { src: 'linkedin', href: 'https://www.linkedin.com/company/finaryhq/' },
  { src: 'facebook', href: 'https://www.facebook.com/Finary-104848758108887' },
  { src: 'youtube', href: 'https://www.youtube.com/channel/UCRCCAnVyzDTcqNYh0pDcq7Q' },
  { src: 'twitter', href: 'https://twitter.com/finaryhq' },
];
